export const assetsDir = "/assets"
export const previewDir = "/vorschau"

export function getFrontendOrigin() {
  const vercelEnv = process.env.NEXT_PUBLIC_VERCEL_ENV
  const vercelProdHost = process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL
  const vercelBranchHost = process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL
  const vercelHost = vercelEnv === "production" ? vercelProdHost : vercelBranchHost
  const vercelUrl = vercelHost && `https://${vercelHost}`

  const frontendOrigin = vercelUrl || process.env.NEXT_PUBLIC_FRONTEND_ORIGIN

  if (!frontendOrigin) {
    throw new Error("Please set NEXT_PUBLIC_FRONTEND_ORIGIN")
  }

  return frontendOrigin
}

export const routes = {
  home: "/",
  search: "/suche/",
  formatSearch: (query: string) => `/suche/?q=${query}`,
  bollerwagen: "/bollerwagen/",
  laufraeder: "/laufraeder/",
  scooter: "/scooter/",
  federwiegen: "/federwiegen/",
  bStock: "/b-ware/",
  cookies: "/cookies/",
  legal: "/impressum/",
  privacy: "/datenschutz/",
  warranty: "/garantieerklaerung/",
  revocation: "/widerruf/",
  delivery: "/versand__lieferung/",
  payments: "/zahlungsweisen/",
  terms: "/agb/",
  contact: "/kontakt/",
  formatContactOption: (slug: string) => `/kontakt?auswahl=${slug}`,
  shipmentTracking: "/tracking/",
  formatShipmentTracking: (parcelloShipmentId: string) => `/tracking?id=${parcelloShipmentId}`,
  cart: "/bestellung/",
  checkout: "/bestellung/",
  orderComplete: "/bestellung/abgeschlossen/",
  orderCompleteCallback: "/api/order/callback/",
  accessories: "/zubehoer/",
  formatProductAccessories: (slug: string) => `/zubehoer/${slug}/`,
  spareParts: "/ersatzteile/",
  formatProduct: (slug: string) => `/product/${slug}/`,
  jobs: "/jobs/",
  formatJob: (slug: string) => `/jobs/${slug}/`,

  // api
  enableDraftMode: "/api/draft-mode/enable",
  disableDraftMode: "/api/draft-mode/disable",
} as const
